import React, { Component } from 'react';
import { Modal, Button, Select, Input, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import TableC from '../../../basicElement/TableC';
import '../index.less';

const Option = Select.Option;

class MedicationSituation extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
        visitPeriodList: [],
        routeOptionList: [],
        currentGroupStartIdx: -1,
        parentData: [],
    }

    show = (index, parentData) => {
        let groupStartIdx = index;

        // 获取合并组所有行（首行索引 → 首行索引+rowSpan-1）
        const groupRowSpan = parentData[groupStartIdx].rowSpan;
        const groupEndIdx = groupStartIdx + groupRowSpan - 1;
        const groupRows = parentData.slice(groupStartIdx, groupEndIdx + 1);

        // 复制合并组数据作为弹窗数据源（避免直接修改原数据）
        const modalDataSource = groupRows.map((row, idx) => ({
            ...row,
            key: `modal-${idx}`,
        }));


        this.setState({
            parentData,
            visible: true,
            data: modalDataSource,
            currentGroupStartIdx: groupStartIdx,
        }, () => {
            this.queryAdministrationRouteList()
            this.queryVisitCycleType();
            (modalDataSource || []).map((el, index) => {
                const { visitCycleCount, visitCycleType } = el;
                this.queryMedicationCycleType(visitCycleCount, visitCycleType, index);
            });
        });
    }

    queryAdministrationRouteList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryAdministrationRouteList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    routeOptionList: res.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    queryVisitCycleType = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryVisitCycleType,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { visitCycleType } = res;
                this.setState({
                    visitPeriodList: visitCycleType,
                })
            }
        };
        $.sendRequest(options);
    }

    queryMedicationCycleType = (visitCycleCount, visitCycleType, index) => {
        if (!visitCycleType) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryMedicationCycleType,
            data: {
                visitCycleType,
                visitCycleCount,
            },
            dataType: 'json',
            doneResult: res => {
                const { medicationCycleType } = res;
                const { data } = this.state;
                data[index].cycleRangeList = medicationCycleType;
                this.setState({
                    data,
                }, () => {
                    if (visitCycleCount === null) {
                        this.handleChange('--', 'medicationCycleShow', index);
                    }
                })
            }
        };
        $.sendRequest(options);
    }

    queryMedicationCount = (visitCycleCount, visitCycleType, medicationCycleCount, medicationCycleType, index) => {
        if (!visitCycleType || !medicationCycleType) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryMedicationCount,
            data: {
                visitCycleType,
                visitCycleCount,
                medicationCycleCount,
                medicationCycleType,
            },
            dataType: 'json',
            doneResult: res => {
                const { medicationCount: obj } = res;
                const { data } = this.state;
                data[index].medicationShow = (obj.medicationCount || obj.medicationCount == 0) ? `${obj.medicationCount}次` : '0次';
                data[index].evaluateHospitalMedicationFrequencyOptimizeId = obj.id;
                this.setState({
                    data,
                })
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
            loading: false,
            currentGroupStartIdx: -1,
        });
    }

    // 弹窗确定：将修改后的数据回写到父Table
    // submit = () => {
    //     const { handleTableChange, handleMedicationSituationChange } = this.props;
    //     const { data, currentGroupStartIdx, parentData } = this.state;
    //     if (currentGroupStartIdx === -1) return;

    //     // 复制父数据源，避免直接修改
    //     const newParentData = [...parentData];
    //     // 是否有未填项，用作校验必填
    //     let isBlank = false;   
    //     // 替换合并组对应的行数据
    //     this.setState({ loading: true });
    //     data.forEach((modalRow, idx) => {
    //         const parentRowIdx = currentGroupStartIdx + idx;
    //         const keyArr = [
    //             'routeType',
    //             'routeId',
    //             'routeName',
    //             'drugName',
    //             'visitCycleShow',
    //             'medicationCycleShow', 
    //             'medicationShow',
    //             // 'visitCycleCount',
    //             'visitCycleType',
    //             // 'medicationCycleCount',
    //             'medicationCycleType',
    //             'evaluateHospitalMedicationFrequencyOptimizeId',
    //         ];


    //         if (newParentData[parentRowIdx]) {
    //             keyArr.map(keyValue => {

    //                 if (modalRow[keyValue] == null || modalRow[keyValue] == undefined || modalRow[keyValue] == '') {
    //                     isBlank = true;
    //                     return 
    //                 } else {
    //                     handleMedicationSituationChange(modalRow[keyValue], keyValue, parentRowIdx);
    //                 }
    //             });
    //         }
    //     });

    //     if (isBlank) {
    //         this.setState({ loading: false });
    //         return message.warning('有未填项！')
    //     }

    //     this.hide();
    // };

    submit = () => {
        const props = this.props;
        const state = this.state;
        const handleMedicationSituationChange = props.handleMedicationSituationChange;
        const data = state.data;
        const currentGroupStartIdx = state.currentGroupStartIdx;

        // 边界判断
        if (currentGroupStartIdx === -1) {
            return;
        }

        this.setState({ loading: true });

        // 1. 初始化变量
        var isBlank = false; // React 15兼容：var更稳妥（若babel未配置let/const）
        var updateList = [];
        var keyArr = [
            'routeType',
            'routeId',
            'routeName',
            'drugName',
            'visitCycleShow',
            'medicationCycleShow', 
            'medicationShow',
            'visitCycleType',
            'medicationCycleType',
            'evaluateHospitalMedicationFrequencyOptimizeId',
        ];

        // 2. 遍历数据收集更新项 + 校验必填
        data.forEach(function (modalRow, idx) {
            var parentRowIdx = currentGroupStartIdx + idx;
            keyArr.forEach(function (keyValue) {
                var value = modalRow[keyValue];
                // 判空（React 15兼容：无?.，直接判断）
                if (value == null || value === '') {
                    isBlank = true;
                    return;
                }
                // 收集更新项
                updateList.push({
                    index: parentRowIdx,
                    key: keyValue,
                    value: value
                });
            });
        });

        // 3. 校验未填项
        if (isBlank) {
            this.setState({ loading: false });
            message.warning('有未填项！');
            return;
        }

        // 4. 批量更新（仅调用一次父组件方法）
        handleMedicationSituationChange(updateList);

        // 5. 隐藏弹窗 + 结束加载
        this.hide();
        this.setState({ loading: false });
    };

    handleChange = (value, key, index) => {
        const { data, visitPeriodList } = this.state;
        switch (key) {
            case 'routeId':
                const { routeOptionList } = this.state;
                data[index][key] = value;
                if (value) {
                    const { routeName, routeType } = routeOptionList.filter(el => el.evaluateAdministrationRouteId == value)[0] || {};
                    data[index]['routeType'] = routeType;
                    data[index]['routeName'] = routeName;
                } else {
                    data[index]['routeType'] = undefined;
                    data[index]['routeName'] = undefined;
                }
                break;
            case 'visitCycleShow':
                const { visitCycleCount, visitCycleType } = visitPeriodList.filter(el => el.visitCycleShow == value)[0] || {};
                data[index][key] = value;
                data[index]['visitCycleCount'] = visitCycleCount;
                data[index]['visitCycleType'] = visitCycleType;
                data[index]['medicationCycleCount'] = undefined;
                data[index]['medicationCycleType'] = undefined;
                data[index]['medicationCycleShow'] = undefined;
                data[index]['medicationShow'] = undefined;
                break;
            case 'medicationCycleShow':
                const { medicationCycleCount, medicationCycleType } = (data[index].cycleRangeList || []).filter(el => el.medicationCycleShow == value)[0] || {};
                data[index][key] = value;
                data[index]['medicationCycleCount'] = medicationCycleCount;
                data[index]['medicationCycleType'] = medicationCycleType;
                data[index]['medicationShow'] = undefined;
                break;
            default:
                data[index][key] = value;
                break;
        }

        this.setState({ data }, () => {
            const { visitCycleCount, visitCycleType, medicationCycleCount, medicationCycleType } = this.state.data[index] || {};
            switch (key) {
                case 'visitCycleShow':
                    this.queryMedicationCycleType(visitCycleCount, visitCycleType, index);
                    break;
                case 'medicationCycleShow':
                    this.queryMedicationCount(visitCycleCount, visitCycleType, medicationCycleCount, medicationCycleType, index);
                    break;
            }
        });
    }

    getColumns = () => {
        const columns = [{
            title: '给药途径',
            dataIndex: 'routeId',
            key: 'routeId',
            width: 120,
            render: (text, record, index) => {
                const { routeOptionList } = this.state;
                const routeOption = (routeOptionList || []).map(el => <Option value={el.evaluateAdministrationRouteId}>{el.routeName}</Option>);
                return <Select
                    placeholder='请选择'
                    style={{ width: 100 }}
                    allowClear
                    value={text}
                    onChange={(value) => this.handleChange(value, 'routeId', index)}
                >
                    {routeOption}
                </Select>
            }
        }, {
            title: '给药类别',
            dataIndex: 'routeType',
            key: 'routeType',
            width: 120,
        }, {
            title: '药物名称',
            dataIndex: 'drugName',
            key: 'drugName',
            width: 120,
            render: (text, record, index) => {
                return <Input
                    placeholder='请输入'
                    style={{ width: 100 }}
                    allowClear
                    value={text}
                    onChange={(e) => this.handleChange(e.target.value, 'drugName', index)}
                />
            }
        }, {
            title: '来院访视周期',
            dataIndex: 'visitCycleShow',
            key: 'visitCycleShow',
            width: 100,
            className: 'header-blue',
            render: (text, record, index) => {
                const { visitPeriodList } = this.state;
                const visitPeriodOption = (visitPeriodList || []).map(el => <Option value={el.visitCycleShow}>{el.visitCycleShow}</Option>)
                return <Select
                    placeholder='请选择'
                    style={{ width: 100 }}
                    allowClear
                    value={text}
                    onChange={(value) => this.handleChange(value, 'visitCycleShow', index)}
                >
                    {visitPeriodOption}
                </Select>
            }
        }, {
            title: '来院用药频率(指的是患者来院访视用药)',
            dataIndex: 'medicationCycleShow',
            key: 'medicationCycleShow',
            width: 120,
            className: 'header-orange',
            render: (text, record, index) => {
                const { cycleRangeList } = record;
                const cycleRangeOption = (cycleRangeList || []).map(el => <Option value={el.medicationCycleShow}>{el.medicationCycleShow}</Option>)
                return <Select
                    placeholder='请选择'
                    style={{ width: 100 }}
                    allowClear
                    value={text}
                    onChange={(value) => this.handleChange(value, 'medicationCycleShow', index)}
                >
                    {cycleRangeOption}
                </Select>
            }
        }, {
            title: '治疗期来院用药次数',
            dataIndex: 'medicationShow',
            key: 'medicationShow',
            width: 120,
            render: (text, record, index) => {
                return <Input
                    placeholder='请输入'
                    style={{ width: 100 }}
                    allowClear
                    value={text}
                    onChange={(e) => this.handleChange(e.target.value, 'medicationShow', index)}
                />
            }
        }
        ];
        return columns
    }


    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="用药情况"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="900px"
                bodyStyle={{ maxHeight: 400 }}
            >
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div style={{ marginBottom: 8, color: '#666' }}>
                        若静脉数更新时【方案系数设置】下的给药系数（静脉系数）会同步自动更新，若有需要可在方案系数设置界面手动维护
                    </div>
                    <div>
                        <TableC
                            rowKey={'key'}
                            data={data}
                            loading={loading}
                            scroll={{ x: 300, y: 400 }}
                            columns={this.getColumns()}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default MedicationSituation;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/MedicationSituation.js